import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import PDFViewer from "./PDFViewer";
// Semanti UI Component
import { Segment, Grid, Button, Loader,Icon,Modal,Message } from "semantic-ui-react";

//const url = "https://s3.amazonaws.com/lmla-resultados/";

const url = process.env.REACT_APP_S3

class OrderCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
      validLink: false,
      isLoading: true,
      error: null,
      showModal: false
    };
  }

  toggleModal = () => {
    this.setState((prevState) => ({ showModal :!prevState.showModal}));
  }

  componentDidMount() {
    this.setState({ validLink: false, isLoading: true });

    fetch(`${url}${this.props.order.link_to_pdf}`, {
      method: 'GET'
    })
      .then(res => {
        // En fetch, res.ok es true si el código de estado es exitoso (200-299)
        // Si el archivo no existe o da un error de S3, res.ok será false
        if (res.ok) {
          this.setState({ validLink: true, isLoading: false });
        } else {
          this.setState({ validLink: false, isLoading: false });
        }
      })
      .catch(error => {
        console.error("Error consultando S3 con fetch:", error);
        this.setState({ validLink: false, isLoading: false });
      });
  }

  componentDidUpdate(prevProps) {
    if (this.props.order.orderNumber !== prevProps.order.orderNumber) {
      
      this.setState({ validLink: false, isLoading: true });

      fetch(`${url}${this.props.order.link_to_pdf}`, {
      method: 'GET'
      })
      .then(res => {
        // En fetch, res.ok es true si el código de estado es exitoso (200-299)
        // Si el archivo no existe o da un error de S3, res.ok será false
        if (res.ok) {
          this.setState({ validLink: true, isLoading: false });
        } else {
          this.setState({ validLink: false, isLoading: false });
        }
      })
      .catch(error => {
        console.error("Error consultando S3 con fetch:", error);
        this.setState({ validLink: false, isLoading: false });
      });
    }
  }
  
  render() {
    const {
      orderNumber,
      physician,
      service,
      insurance,
      historyNumber,
      phone,
      office,
      bed,
      date,
      link_to_pdf
    } = this.props.order;

    const { selectedPatientID } = this.props;

    const { validLink, isLoading } = this.state;

    const tempDate = date.slice(0, 10);
    const splitedDate = tempDate.split("-");
    const month = [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ][Number(splitedDate[1]) - 1];
    const formatedDate = splitedDate[2] + "-" + month + "-" + splitedDate[0];

    const amazonPDF = `${url}${link_to_pdf}?nocache=${new Date().getTime()}`;
    return (
      <div>
        <div id="segment" style={styles.segment}>
          INFORMACIÓN DE LA ORDEN
        </div>
        <Segment>
          <Grid divided="vertically">
            <Grid.Row columns="equal">
              <Grid.Column>
                <div>
                  <strong style={{ width: "100px", display: "inline-block" }}>
                    Paciente:
                  </strong>
                  {this.props.patient_fullname}
                </div>
                <div>
                  <strong style={{ width: "100px", display: "inline-block" }}>
                    Identificación:
                  </strong>
                  {this.props.patient_id}
                </div>
                <div>
                  <strong style={{ width: "100px", display: "inline-block" }}>
                    Historia:
                  </strong>
                  {historyNumber}
                </div>
                <div>
                  <strong style={{ width: "100px", display: "inline-block" }}>
                    Orden:
                  </strong>
                  {orderNumber}
                </div>
                <div>
                  <strong style={{ width: "100px", display: "inline-block" }}>
                    Fecha:
                  </strong>
                  {formatedDate}
                </div>
                {/* <div>
                  <strong style={{ width: "100px", display: "inline-block" }}>
                    Correo:
                  </strong>
                  {email_address_address}
                </div> */}
                <div>
                  <strong style={{ width: "100px", display: "inline-block" }}>
                    Teléfono:
                  </strong>
                  {phone}
                </div>
              </Grid.Column>
              <Grid.Column>
                <div>
                  <strong style={{ width: "100px", display: "inline-block" }}>
                    Empresa:
                  </strong>
                  {insurance}
                </div>
                <div>
                  <strong style={{ width: "100px", display: "inline-block" }}>
                    Médico:
                  </strong>
                  {physician}
                </div>
                <div>
                  <strong style={{ width: "100px", display: "inline-block" }}>
                    Consultorio:
                  </strong>
                  {office}
                </div>
                <div>
                  <strong style={{ width: "100px", display: "inline-block" }}>
                    Servicio:
                  </strong>
                  {service}
                </div>

                <div>
                  <strong style={{ width: "100px", display: "inline-block" }}>
                    Cama:
                  </strong>
                  {bed}
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row id="generatePDF" columns="one">
              <Grid.Column textAlign="center">
              <Button
                  onClick={() =>
                    this.props.showPatientOrdersList({
                      practitioner: this.props.order.physician,
                      patient_id: selectedPatientID,
                      startDate: this.props.filterRange?.startDate || null,
                      endDate: this.props.filterRange?.endDate || null,
                      search: this.props.filterRange?.text || null
                    })
                  }
                  color="blue"
                  icon labelPosition="left"
                  style={{ marginRight:"1em"}}
                >
                  <Icon name="arrow left"></Icon>
                  Volver
                </Button>
                <Button
                    color={isLoading ? "grey": validLink ? "blue":"orange"}
                    icon
                    labelPosition="left"
                    onClick={this.toggleModal}
                    disabled={isLoading || !validLink}
                    loading={isLoading}
                  >
                    <Icon name={validLink ? "file pdf" : "warning sign"} />
                   {isLoading ? "Verificando...": validLink ? "Ver PDF" : "PDF No Disponible"}
                  </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>

        <Modal
          open={this.state.showModal}
          onClose={this.toggleModal}
          size="large"
          closeIcon
        >
          <Modal.Header style={{ fontSize: '14px', padding: '6px' }}>Resultado en PDF</Modal.Header>
          <Modal.Content style={{ height: '80vh', overflow: 'auto' }}>
            {validLink ? (
              <iframe
                src={amazonPDF}
                width="100%"
                height="100%"
                title="PDF"
                style={{ border: "none" }}
              />
            ):(
              <div style={{ padding: "2em", textAlign: "center" }}>
                <Message warning icon>
                  <Icon name="file pdf outline" />
                  <Message.Content>
                    <Message.Header>El documento no se encuentra disponible</Message.Header>
                    El archivo PDF solicitado no está listo o fue removido del servidor. Por favor, intente más tarde.
                  </Message.Content>
                </Message>
              </div>
            )}
             
          </Modal.Content>
          <Modal.Actions style={{ padding:'6px'}}>
            <Button color="red" onClick={this.toggleModal}>
              <Icon name="close" /> Cerrar
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
  );
  }
}

const styles = {
  segment: {
    textAlign: "center",
    fontSize: "16px",
    color: "black",
    position: "relative",
    background: "#fff",
    margin: "1rem 0 1rem 0",
    padding: "1em 1em",
    borderRadius: "0.28571429rem",
    border: "2px solid #00ACC9",
    //backgroundColor: "#e05c5c",
    boxShadow: "0 1px 2px 0 rgba(34, 36, 38, 0.15)"
  },
  buttonSegment: {
    margin: "0 0 1rem 0"
  }
};

OrderCard.propTypes = {
  order: PropTypes.shape({
    orderNumber: PropTypes.string,
    physician: PropTypes.string,
    service: PropTypes.string,
    insurance: PropTypes.string,
    historyNumber: PropTypes.string,
    phone: PropTypes.string,
    office: PropTypes.string,
    bed: PropTypes.string
  }).isRequired
};

function mapStateToProps(state) {
  return {
    order: state.patientOrderResults.order,
    patient_id: state.selectedPatient.patient_id,
    patient_fullname: state.selectedPatient.fullname,
    filterRange: state.examsByOrder.filterRange
  };
}

export default connect(mapStateToProps, {})(OrderCard);
